import ApexCharts from 'apexcharts';

export async function generateChartDataUri(options: any) {
  const el = document.createElement('div');
  el.style.width = '1920px';
  el.style.margin = '0 auto';
  el.style.position = 'absolute';
  el.style.top = '0';
  el.style.left = '-1920px';
  el.style.zIndex = '-10';

  document.body.append(el);
  const chart = new ApexCharts(el, options);
  await chart.render();
  await chart.updateOptions({}, false, false);
  // await delay(1000);
  const dataURI = await chart.dataURI();
  chart.destroy();
  el.remove();
  return dataURI;
}
